import screenbanner from "./images/banner/1.jpg";
import mobilebanner from "./images/banner/2.jpg";
import location1 from "./images/blog/News/4.jpg";
import location2 from "./images/blog/News/1.jpg";
import location3 from "./images/blog/News/6.jpg"
import newsShape1 from "./images/shapes/news-one-shape-1.png";

import d1 from "./images/blog/DIY/1.jpg"
import d2 from "./images/blog/DIY/2.jpg"
import d3 from "./images/blog/DIY/3.jpg"


import v1 from "./images/blog/Vastu/1.jpg"
import v2 from "./images/blog/Vastu/2.jpg"
import v3 from "./images/blog/Vastu/3.jpg"
export const Bannerdata = {
  mobilebanner: mobilebanner,
  screenbanner: screenbanner,
};

// Latest Update
export const LatestUpdate = {
  tagline: `Latest News`,
  shape1: newsShape1,
 data: [
    {
      id: 1,
      image: location1,
      alt: "Google",
      date: "01 Jan",
      tag: "Google Leases 5.5 Lakh Sq Ft Office Space in Gurugram, with Plans for Future Expansion",
      title: `Google has secured a significant 550,000 sq ft of office space in Gurugram. `,
      link: "/news-070125",
      review: 2,
    },
    {
      id: 2,
      image: location2,
      alt: "TARC Ltd Reports Rs 1,165 Crore in Pre-Sales for Q3 FY25",
      date: "06 Jan",
      tag: "TARC Ltd Reports Rs 1,165 Crore in Pre-Sales for Q3 FY25",
      title: `TARC Ltd Reports Rs 1,165 Crore in Pre-Sales for Q3 FY25 TARC Ltd Reports Rs 1,165 Crore in Pre-Sales for Q3 FY25`,
      link: "/news-080125",
      review: 3,
    },
    {
      id: 3,
      image: location3,
      alt: "Prestige Group Invests Rs 462",
      date: "30 Oct",
      tag: "Prestige Group Invests Rs 462 Crore to Acquire 17.45 Acres of Land in Bengaluru",
      title:
      `Prestige Group, a leading name in India’s real estate sector, has acquired a prime 17.45-acre
land parcel in Bengaluru`,
      link: "/news-090125",
      review: 5,
    },
  ],
};

// Vastu Tips
export const VastuTips = {
  hide: 1,
  tagline: `Vastu Tips`,
  shape1: newsShape1,
  data: [
    {
      id: 1,
      image: v1,
      alt: "Birla Estates acquire land In sector 71",
      date: "20 Sep",
      tag: "Birla Estates acquire land In sector 71",
      title:
        "Birla Estates, a fully-owned subsidiary of Century Textiles and Industries, has recently acquired a five acre land.",
      link: "#",
      review: 2,
    },
    {
      id: 2,
      image: v2,
      alt: "Ganga Realty Invests Rs 1,200 crore",
      date: "21 Sep",
      tag: "Ganga Realty Invests Rs 1,200 crore ",
      title:
        "Ganga Realty is set to fund its ambitious project through a combination of internal accruals and customer advances. ",
      link: "#",
      review: 3,
    },
    {
      id: 3,
      image: v3,
      alt: "Alphacorp to Invest Rs 350 crone",
      date: "22 Sep",
      tag: "Alphacorp to Invest Rs 350 crone ",
      title:
        "Investment of As 350 more for a luxurious project, signaling a expansion in response to consumer's demand. ",
      link: "#",
      review: 5,
    },
  
  ],
};

// DIY
export const DIY = {
  hide: 1,
  tagline: `DIY - Do It Yourself`,
  shape1: newsShape1,
  data: [
    {
      id: 1,
      image: d1,
      alt: "Birla Estates acquire land In sector 71",
      date: "20 Sep",
      tag: "Birla Estates acquire land In sector 71",
      title:
        "Birla Estates, a fully-owned subsidiary of Century Textiles and Industries, has recently acquired a five acre land.",
      link: "#",
      review: 2,
    },
    {
      id: 2,
      image: d2,
      alt: "Ganga Realty Invests Rs 1,200 crore",
      date: "21 Sep",
      tag: "Ganga Realty Invests Rs 1,200 crore ",
      title:
        "Ganga Realty is set to fund its ambitious project through a combination of internal accruals and customer advances. ",
      link: "#",
      review: 3,
    },
    {
      id: 3,
      image: d3,
      alt: "Alphacorp to Invest Rs 350 crone",
      date: "22 Sep",
      tag: "Alphacorp to Invest Rs 350 crone ",
      title:
        "Investment of As 350 more for a luxurious project, signaling a expansion in response to consumer's demand. ",
      link: "#",
      review: 5,
    },
  ],
};
